import React from "react";

export default function About() {
  return (
    <section id="about" className="bg-gray-950">
      <div className="container mx-auto px-6 py-24 md:py-32">
        <div className="max-w-3xl">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-100 mb-6">
            Daniel Coates
          </h1>
          <h2 className="text-2xl md:text-3xl text-gray-500 font-light mb-8">
            Software Engineer
          </h2>
          <p className="text-lg text-gray-400 mb-10 max-w-2xl leading-relaxed">
            A computer science graduate with a First Class degree, experienced
            across the full development lifecycle. I build clean, reliable software
            and enjoy solving complex problems with practical solutions.
          </p>
          <div className="flex flex-wrap">
            <a
              href="#projects"
              className="inline-flex items-center bg-indigo-600 text-white py-3 px-6 rounded-lg font-medium hover:bg-indigo-700 transition-colors mr-4 mb-4"
            >
              View Projects
            </a>
            <a
              href="#contact"
              className="inline-flex items-center border-2 border-gray-700 text-gray-300 py-3 px-6 rounded-lg font-medium hover:border-gray-500 transition-colors mr-4 mb-4"
            >
              Get in Touch
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/components/About.js